(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ns-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ns-editorial-gallery')) customElements.define('ns-editorial-gallery', class extends HTMLElement {
 connectedCallback() {
  if (this.dataset.ready) return;
  this.dataset.ready='true';
  const track=this.querySelector('.ns-gallery__track'),slides=[...this.querySelectorAll('.ns-gallery__slide')],thumbs=[...this.querySelectorAll('[data-ns-slide]')],dialog=this.querySelector('dialog');
  let index=0;
  const update=()=>{index=Math.round(track.scrollLeft/track.clientWidth);thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)));this.querySelector('[data-ns-count]').textContent=(index+1)+' / '+slides.length;};
  const move=n=>track.scrollTo({left:Math.max(0,Math.min(n,slides.length-1))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.addEventListener('click',e=>{
   const t=e.target.closest('[data-ns-slide]');if(t)move(Number(t.dataset.nsSlide));
   if(e.target.closest('[data-ns-next]'))move(index+1);
   if(e.target.closest('[data-ns-prev]'))move(index-1);
   const z=e.target.closest('[data-ns-zoom]');if(z){const src=z.querySelector('img'),img=dialog.querySelector('img');img.src=src.currentSrc||src.src;img.alt=src.alt;dialog.showModal();}
   if(e.target.closest('[data-ns-close]')||e.target===dialog)dialog.close();
  });
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();move(index+1);}if(e.key==='ArrowLeft'){e.preventDefault();move(index-1);}});
 }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ns-sale-summary"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ns-sale-summary'))customElements.define('ns-sale-summary',class extends HTMLElement{
 connectedCallback(){
  this.card=this.closest('product-card, .ns-product-price');
  if(!this.card)return;
  this.refresh=()=>{
   const list=this.card.querySelector('price-list');
   const source=list?.querySelector('.firstPriceValue')||list?.querySelector('sale-price [data-ns-gross-value]');
   if(!source)return;
   const text=source.textContent.replace(/[^0-9.,-]/g,'');
   const decimal=Math.max(text.lastIndexOf(','),text.lastIndexOf('.'));
   const amount=Number(decimal>=0&&text.length-decimal-1===2?text.slice(0,decimal).replace(/[.,]/g,'')+'.'+text.slice(decimal+1):text.replace(/[.,]/g,''));
   if(Number.isFinite(amount)&&text)this.hidden=Math.abs(Math.round(amount*100)-Number(this.dataset.expected))>1;
  };
  this.observer=new MutationObserver(()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.refresh()})});
  this.observer.observe(this.card,{subtree:true,childList:true,characterData:true});
  this.refresh();
 }
 disconnectedCallback(){this.observer?.disconnect();if(this.frame)cancelAnimationFrame(this.frame)}
});
  } catch(e) { console.error(e); }
})();

})();
